// -----------------------------------------------------------------------------
export const useDateFormat = (dateString: string): string => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString();
  const day = date.getDate().toString();
  return `${day}/${month}/${year}`;
};
